/**
 * ステータス関連
 */

export const PublishStatus4Option = [
  { value: '0', content: '下書き' },
  { value: '1', content: '公開中' },
  // { value: "2", content: "審査中（非公開）" },
];

export const getPublishStatusText = (value: string) => {
  const item = PublishStatus4Option.find((_) => _.value === value);
  return item ? item['content'] : '';
};
